import { CalendarEvent } from './CalendarEvent';

class FixedEvent extends CalendarEvent {
    date: Date;

    constructor(date: Date) {
        super(false);
        this.date = date;
    }

    override occurances(firstDate: Date, lastDate: Date): number {
        return firstDate <= this.date && this.date <= lastDate ? 1 : 0;
    }
};

export { FixedEvent };